export default __webpack_public_path__ + "static/media/space-odyssey.e3a3e6ff57942ed9cd7a52c885af72bc.svg";